module.exports = {
	colors: {
		main: '#2b2668',
		sec: '#f3931f',
		alt: '#2b2668',
	},

	showFunds: false,
	showBuses: false,	
	showHomeworks: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963945618161', '+963940550933', '+963936005152'],
		phones: [],
		address: 'سوريا - حلب / الفرقان، خلف بوظة الشافي - جانب مدرسة عبد الرحمن الكواكبي (سارية حسون سابقًا)',
		data: [],
		email: null,
		facebook: null,
		privacy: null,
		details: [
			{
				title: 'معهد قلعه جي',
				content: [
					'✨️متخصص في دعم الطلاب بمختلف المراحل الدراسية، حيث يقدّم:',
					'📘 دورات الشهادة الإعدادية (تاسع).',
					'📗 دورات الشهادة الثانوية (بفرعيها العلمي والأدبي).',
					'🌍 دورات لغات (إنكليزية – فرنسية – ألمانية - تركية ).',
					'✨️ يهدف المعهد إلى رفع مستوى الطلاب علميًا وتقديم بيئة تعليمية مجهزة بأحدث الوسائل التعليمية ، و التعاون مع  نخبة من المدرسين ذوي الخبرة، وبرامج تدريسية مدروسة تركز على الفهم العميق، التدريب المستمر، وتحضير الطلاب للامتحانات بأفضل صورة.'
				],
			},
		],
	},

	pwa: {
		name: 'Kalaji Institute',
		shortName: 'Kalaji Institute',
		description: 'Kalaji Institute app - portal version for Kalaji Institute mobile app.',
	},
};
